var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavLab({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 8.73L20.1101 17.49H20.0701C20.6105 18.4176 20.614 19.5631 20.0794 20.494C19.5448 21.4249 18.5536 21.9992 17.4801 22H6.48015C5.40669 21.9992 4.41548 21.4249 3.88089 20.494C3.34631 19.5631 3.34984 18.4176 3.89015 17.49L9.00015 8.73V4H8.00015C7.44786 4 7.00015 3.55228 7.00015 3C7.00015 2.44772 7.44786 2 8.00015 2H16.0001C16.5524 2 17.0001 2.44772 17.0001 3C17.0001 3.55228 16.5524 4 16.0001 4H15.0001V8.73ZM11.0001 9C10.9966 9.17268 10.9483 9.3415 10.8601 9.49L10.0001 11H14.0001L13.1401 9.5C13.0503 9.34857 13.002 9.17609 13.0001 9V4H11.0001V9ZM17.5201 19.99C17.8753 19.9879 18.2026 19.7975 18.3801 19.49V19.5C18.5588 19.1906 18.5588 18.8094 18.3801 18.5L15.1801 13H8.83015L5.66015 18.49C5.48151 18.7994 5.48151 19.1806 5.66015 19.49C5.8377 19.7975 6.16503 19.9879 6.52015 19.99H17.5201ZM10.0001 15C9.44786 15 9.00015 15.4477 9.00015 16C9.00015 16.5523 9.44786 17 10.0001 17C10.5524 17 11.0001 16.5523 11.0001 16C11.0001 15.4477 10.5524 15 10.0001 15ZM14.0001 16C13.4479 16 13.0001 16.4477 13.0001 17C13.0001 17.5523 13.4479 18 14.0001 18C14.5524 18 15.0001 17.5523 15.0001 17C15.0001 16.4477 14.5524 16 14.0001 16Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLab);
export default ForwardRef;